// utils/dateUtils.js

/**
 * 年度、決算月から画面表示する決算期を生成する関数
 *
 * @param {string} period - 決算月（例："12月"など）
 * @param {string} year - 年度（例："2024年度"）
 * @returns {string} - 表示決算期（例："2025年12月期"）
 */
export const getPeriodYm = (period, year) => {
  return (period !== '12月' ? parseInt(year.slice(0, 4)) + 1 + year.slice(4, 5) : year.slice(0, -1)) + period + '期'
}

/**
 * Dateオブジェクトを"YYYY-MM-DD"形式の文字列に整形する関数
 *
 * @param {Date | null} date - Dateオブジェクトまたはnull
 * @returns {string} - フォーマットされた日付文字列、nullの場合は空文字列を返す
 */
export const formatDateToString = (date) => {
  if (!date) return ''
  const yyyy = date.getFullYear()
  const mm = String(date.getMonth() + 1).padStart(2, '0')
  const dd = String(date.getDate()).padStart(2, '0')
  return `${yyyy}-${mm}-${dd}`
}

/**
 * 決算期の範囲を取得する関数
 *
 * @param {string} periodString - 決算期文字列（例："2024年3月期"）
 * @returns {{ minDate: Date | null; maxDate: Date | null }} - 最小日付と最大日付
 */
export const getFiscalPeriodRange = (periodString) => {
  const match = periodString.match(/^(\d{4})年(\d{1,2})月期$/)
  if (!match) return { minDate: null, maxDate: null }

  const year = parseInt(match[1], 10)
  const fiscalMonth = parseInt(match[2], 10)

  let startYear, startMonth, endYear, endMonth, endDay

  if (fiscalMonth === 12) {
    startYear = year
    startMonth = 0 // 1月（0-index）
    endYear = year
    endMonth = 11 // 12月（0-index）
    endDay = 31
  } else {
    startYear = year - 1
    startMonth = fiscalMonth // fiscalMonthは1ベース、Dateの月は0ベースなので fiscalMonthはそのままでOK
    endYear = year
    endMonth = fiscalMonth - 1
    endDay = new Date(endYear, endMonth + 1, 0).getDate()
  }

  const minDate = new Date(startYear, startMonth, 1)
  const maxDate = new Date(endYear, endMonth, endDay)

  return { minDate, maxDate }
}

/** 雇用区分マージ処理 */
export const mergeEmploymentTypes = (types) => {
  const map = new Map()

  for (const item of types) {
    const key = item.employmentType
    const current = map.get(key)

    if (!current) {
      map.set(key, item)
    } else {
      const currentDate = current.validEndDate ? new Date(current.validEndDate) : null
      const itemDate = item.validEndDate ? new Date(item.validEndDate) : null

      if (currentDate === null) continue
      if (itemDate === null) {
        map.set(key, item)
        continue
      }
      if (itemDate > currentDate) {
        map.set(key, item)
      }
    }
  }

  return Array.from(map.values())
}
